import { addLabelArray } from "helpers/addLabelArray";
import { newDate } from "helpers/dateTools";

export const CLEAR_PURCHASES = 'CLEAR_PURCHASES';
export const CHANGE_CRE_LICENSE_PURCHASES = 'CHANGE_CRE_LICENSE_PURCHASES';
export const GET_LICENSES_PURCHASES = 'GET_LICENSES_PURCHASES';
export const GET_PURCHASES = 'GET_PURCHASES';
export const SET_PURCHASES_FILTERS = 'SET_PURCHASES_FILTERS';

const INITIAL_STATE = {

    // filters
    startDate: newDate(),
    endDate: newDate(),
    creLicenseSelected: "",

    //info
    creLicenses: [],
    purchases: [],

}

export const purchasesReducer = (state = INITIAL_STATE, { type, payload }) => {
    switch (type) {
        // filter
        case SET_PURCHASES_FILTERS:
            return {
                ...state,
                [payload.name]: payload.value,
            };
        case CHANGE_CRE_LICENSE_PURCHASES:
            return {
                ...state,
                creLicenseSelected: payload,
            };
        //request
        case GET_LICENSES_PURCHASES:
            return {
                ...state,
                creLicenses: addLabelArray(payload, "creLicense")
            }
        case GET_PURCHASES:
            return {
                ...state,
                purchases: payload,
            }
        case CLEAR_PURCHASES:
            return {
                ...state,
                ...INITIAL_STATE,
            };
        default:
            return state;
    }
}
